import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Header,
    Textarea,
    Container,
    SpaceBetween,
    Box,
    Grid,
    Link,
    ExpandableSection,
    FileUpload,
    Modal,
    Spinner,
    Checkbox,
    ColumnLayout,
    Select,
    Table,
    Popover
} from "@amzn/awsui-components-react";
import { configureGenericS3 } from "src/context/AuthContextUtility";
import CustomMultiHybridInputAndSelect from "src/Ateam-BI/Templates/components/CustomMultiHybridInputAndSelect";
import { RIPPLE_APPROVER_TYPES, RippleKeys } from "./Constants";
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { createAuditLog } from "src/Ateam-BI/Templates/Utils/AppActivityUtils";
import './styles.scss'
import RippleMultiInputKeyValue from "src/generic-components/Ripple/RippleMultiInputKeyValue";
import { createRipple, deleteRipple, updateRipple } from "src/utilities/AppSyncPlusAPIs";
import { useSelector } from "react-redux";
import { useSuggestedLogins } from "src/hooks/useSuggestedLogins";
const RippleComponent = (props) => {

    // const [rippleConfiguration, setRippleConfiguration] = useState({});
    const userId = useSelector((globalState) => globalState.auth.userId);
    const rippleConfigurationEdited = useRef({});
    const [approvalOnResults, setApprovalOnResults] = useState(false);
    const [isDynamicApproversAllowed, setIsDynamicApproversAllowed] = useState(false);
    const [nextSteps, setNextSteps] = useState(true);
    const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
    const [fieldMetadata, setFieldMetadata] = useState({});
    const [nextJob, setNextJob] = useState(null);
    const [resendOldParameters, setResendOldParameters] = useState(false);
    const [reloadParameters, setReloadParameters] = useState(false);
    const [markedToDelete, setMarkedToDelete] = useState(false);

    const DYNAMIC_APPROVERS_INFO = "When enabled, this option will replace the current approvers with a dynamic list of approvers sent through SNS from the Contico job."
    const NEXT_JOB_VALUES = {
        load_to_fdv: 'load_to_fdv',
        custom_job: 'custom_job'
    }

    useEffect(() => {
        initView()
    }, [])

    useEffect(() => {
        if (props.isEditMode || props.isNewMode) {
            let oldParameters = []
            if (props.rippleConfiguration?.hasOwnProperty(RippleKeys.parameters)) {
                oldParameters = props.rippleConfiguration[RippleKeys.parameters]
            }
            let parameters = []
            if (nextJob?.value == NEXT_JOB_VALUES.load_to_fdv) {
                let requiredParameters = [
                    { "label": "trigger_workiva", "default_value": ["false"] }, { "label": "RedShiftDatasetName" }, { "label": "GlueCatalogDatasetName" }, { "label": "partitionField" }]
                parameters = populateParams(requiredParameters, oldParameters)
                rippleConfigurationEdited.current['parameters'] = parameters
            } else if (nextJob?.value == NEXT_JOB_VALUES.custom_job) {
                let requiredParameters = [
                    { "label": "sec_contico_job_name" }
                ]
                parameters = populateParams(requiredParameters, oldParameters)
                rippleConfigurationEdited.current['parameters'] = parameters
            }
            rippleConfigurationEdited.current['task'] = nextJob?.value
            setReloadParameters(true)
        }
    }, [nextJob])

    useEffect(() => {
        rippleConfigurationEdited.current['approval_required'] = approvalOnResults
        rippleConfigurationEdited.current['resend_old_parameters'] = resendOldParameters
        rippleConfigurationEdited.current['is_dynamic_approvers_allowed'] = isDynamicApproversAllowed
    }, [approvalOnResults, resendOldParameters, isDynamicApproversAllowed])

    useEffect(() => {
        // setRippleConfiguration(props.rippleConfiguration)
        if (!props.isNewMode
            && props.rippleConfiguration?.hasOwnProperty(RippleKeys.approval_required)
            && props.rippleConfiguration[RippleKeys.approval_required] != null) {
            setApprovalOnResults(props.rippleConfiguration[RippleKeys.approval_required])
        }
        if (!props.isNewMode
            && props.rippleConfiguration?.hasOwnProperty(RippleKeys.resend_old_parameters)
            && props.rippleConfiguration[RippleKeys.resend_old_parameters] != null) {
            setResendOldParameters(props.rippleConfiguration?.[RippleKeys.resend_old_parameters])
        }
        if (!props.isNewMode
            && props.rippleConfiguration?.hasOwnProperty(RippleKeys.is_dynamic_approvers_allowed)
            && props.rippleConfiguration[RippleKeys.is_dynamic_approvers_allowed] != null) {
            setIsDynamicApproversAllowed(props.rippleConfiguration?.[RippleKeys.is_dynamic_approvers_allowed])
        }
        rippleConfigurationEdited.current = JSON.parse(JSON.stringify(props.rippleConfiguration))
    }, [props.rippleConfiguration])

    useEffect(() => {
        if (props.isEditMode && props.rippleConfiguration?.[RippleKeys.ripple_id]) {
            setNextSteps(props.rippleConfiguration?.[RippleKeys.task] ? true : false)
            setNextJob(JSON.parse(JSON.stringify({ 'label': props.rippleConfiguration?.[RippleKeys.task], 'value': props.rippleConfiguration?.[RippleKeys.task] })))
        }
    }, [props.isEditMode])

    useEffect(() => {
        if (!rippleConfigurationEdited.current.hasOwnProperty(RippleKeys.ripple_id)) {
            rippleConfigurationEdited.current[RippleKeys.ripple_id] = getUniqueId()
        }
        props.register(rippleConfigurationEdited.current[RippleKeys.ripple_id])
    }, [])

    useEffect(() => {
        if (props.shouldSubmit) {
            submitRequest()
        }
    }, [props.shouldSubmit])

    const getCurrentTime = () => {
        return Date.now();
    }

    function submitRequest() {
        rippleConfigurationEdited.current[RippleKeys.app_id] = props.appId
        rippleConfigurationEdited.current[RippleKeys.mapping_id] = props.mappingId
        rippleConfigurationEdited.current[RippleKeys.id_type] = props.idType

        if (rippleConfigurationEdited.current?.ripple_id?.startsWith('temp_ripple_id_')) {
            if (markedToDelete) {
                props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.temp_ripple_id], {})
            } else {
                // create ripple
                rippleConfigurationEdited.current[RippleKeys.temp_ripple_id] = rippleConfigurationEdited.current.ripple_id
                delete rippleConfigurationEdited.current.ripple_id
                createAuditLog(`RIPPLE`, `ADD_REQ#${getCurrentTime()}`, "Adding a new ripple", JSON.stringify({}), JSON.stringify(rippleConfigurationEdited.current), "ADD REQ", userId, function onSuccess(result) {
                    createRipple(rippleConfigurationEdited.current, function onSuccess(response) {
                        // props.deRegister(rippleConfigurationEdited.current[RippleKeys.temp_ripple_id])
                        // props.register(rippleConfigurationEdited.current[RippleKeys.ripple_id])
                        props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.temp_ripple_id], response)
                    }, function onFailure(response) {
                        props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.temp_ripple_id], response)
                    })
                }, function onFailure(error) {
                    setErrorMessage(`Could not log audit. Adding the template was not attempted ${error?.errors[0]?.message}`)
                })
            }
        } else {
            if (markedToDelete) {
                // delete
                createAuditLog(`RIPPLE`, `DELETE_REQ#${getCurrentTime()}`, "Deleting a ripple", JSON.stringify({}), JSON.stringify(rippleConfigurationEdited.current), "DELETE REQ", userId, function onSuccess(result) {
                    deleteRipple(rippleConfigurationEdited.current[RippleKeys.ripple_id], rippleConfigurationEdited.current[RippleKeys.ripple_mapping_id], function onSuccess(response) {
                        props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.ripple_id], response)
                    }, function onFailure(response) {
                        props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.ripple_id], response)
                    })
                }, function onFailure(error) {
                    setErrorMessage(`Could not log audit. Adding the template was not attempted ${error?.errors[0]?.message}`)
                })

            } else {
                // update ripple
                createAuditLog(`RIPPLE`, `UPDATE_REQ#${getCurrentTime()}`, "Updating a ripple", JSON.stringify({}), JSON.stringify(rippleConfigurationEdited.current), "UPDATE REQ", userId, function onSuccess(result) {
                    updateRipple(rippleConfigurationEdited.current, function onSuccess(response) {
                        // props.deRegister(rippleConfigurationEdited.current[RippleKeys.temp_ripple_id])
                        // props.register(rippleConfigurationEdited.current[RippleKeys.ripple_id])
                        props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.ripple_id], response)
                    }, function onFailure(response) {
                        props.submissionUpdates(rippleConfigurationEdited.current[RippleKeys.ripple_id], response)
                    })
                }, function onFailure(error) {
                    setErrorMessage(`Could not log audit. Adding the template was not attempted ${error?.errors[0]?.message}`)
                })

            }
        }
    }
    function populateParams(requiredParameters, oldParameters) {
        let newParameters = []
        let oldParametersMap = {}
        for (const oldParameter of (oldParameters ?? [])) {
            oldParametersMap[oldParameter['label']] = oldParameter
            newParameters.push(oldParameter)
        }
        for (const requiredParameter of (requiredParameters ?? []) ) {
            if (oldParametersMap.hasOwnProperty(requiredParameter.label)) {
                // ignore this because we will reuse old once
            } else {
                let param = {
                    "label": requiredParameter.label,
                    "field_type": "ripple_input",
                    "field_values": requiredParameter.hasOwnProperty('default_value') ? requiredParameter.default_value : []
                }
                if (requiredParameter.hasOwnProperty('override') && requiredParameter['override']) {
                    param["field_values"] = requiredParameter.hasOwnProperty('default_value') ? requiredParameter.default_value : []
                }
                newParameters.push(param)
            }

        }
        return newParameters
    }

    const getUniqueId = () => {
        let id = `temp_ripple_id_${Date.now().toString()}`
        return id
    }

    const initView = () => {
        configureGenericS3()
        loadEditableFields()
    }

    const loadEditableFields = async () => {
        let res = await getEditableFields()
        res[RippleKeys.APPROVERS] = { values: [{ label: "USER", value: RIPPLE_APPROVER_TYPES.APPROVER }, { label: "LDAP", value: RIPPLE_APPROVER_TYPES.APPROVER_LDAP }] }
        setFieldMetadata(res)
    }


    const postProcessTeamEmails = (value) => {
        return value.replaceAll("@amazon.com", "")
    }

    const approversValidation = (elements) => {
        let emptyValues = true
        elements?.forEach((element) => {
            if (!element.type || !element.alias) {
                emptyValues = false
            }
        })
        return emptyValues
    }

    const getValueKeyValue = (fieldName, subKey = null) => {
        let val = getValue(fieldName, subKey)
        return val
    }

    const getValue = (fieldName, subKey = null) => {
        if (subKey) {
            if (rippleConfigurationEdited.current?.hasOwnProperty(fieldName)) {
                return rippleConfigurationEdited.current[fieldName][subKey]
            } else {
                return null
            }
        } else {
            return rippleConfigurationEdited.current?.[fieldName]
        }
    }

    const updateValueKeyValue = (fieldName, value, subKey = null) => {
        updateValue(fieldName, value, subKey)
    }

    const updateValue = (fieldName, value, subKey = null) => {
        if (subKey) {
            if (!rippleConfigurationEdited.current?.hasOwnProperty(fieldName)) {
                rippleConfigurationEdited.current[fieldName] = {}
            }
            rippleConfigurationEdited.current[fieldName][subKey] = value
        } else {
            rippleConfigurationEdited.current[fieldName] = value
        }
    }

    const getSelectFieldValues = (fieldName) => {
        if (fieldMetadata && fieldMetadata[fieldName] && fieldMetadata[fieldName]['values']) {
            return fieldMetadata[fieldName]['values']
        } else {
            return []
        }
    }

    const mandatoryFieldListener = (key, enableUpdate) => {
        // mandatoryFieldsMissing[key] = enableUpdate
    }
    const resetReload = (value) => {
        setReloadParameters(value)
    }


    const markDelete = () => {
        setMarkedToDelete(true)
    }
    const unMarkDelete = () => {
        setMarkedToDelete(false)
    }

    return (
        <SpaceBetween direction="vertical" size="m" key={rippleConfigurationEdited.current}>
            {
                props.isEditMode || props.isNewMode ?
                    <SpaceBetween>
                        {
                            markedToDelete ? <Box float="right"> <span className='red_badge'>Marked to delete</span> </Box> : <></>
                        }
                        <Box>
                            <Checkbox
                                onChange={({ detail }) =>
                                    setApprovalOnResults(detail.checked)
                                }
                                checked={approvalOnResults}
                            >
                                Approval on Results
                            </Checkbox>

                            <Checkbox
                                onChange={({ detail }) =>
                                    setNextSteps(detail.checked)
                                }
                                checked={nextSteps}
                                disabled={true}
                            >
                                Next steps
                            </Checkbox>

                            <ColumnLayout columns={approvalOnResults ? 2 : 1} borders="vertical">
                                {
                                    nextSteps ? <SpaceBetween direction="vertical" size="xxs">
                                        <Box variant="h2">Next steps</Box>
                                        <Grid
                                            gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}
                                        >
                                            <Box variant="h4">Contico job</Box>
                                            <Select
                                                selectedOption={nextJob}
                                                onChange={({ detail }) =>
                                                    setNextJob(detail.selectedOption)
                                                }
                                                options={[
                                                    { label: NEXT_JOB_VALUES.load_to_fdv, value: NEXT_JOB_VALUES.load_to_fdv },
                                                    { label: NEXT_JOB_VALUES.custom_job, value: NEXT_JOB_VALUES.custom_job },
                                                ]}
                                            />
                                        </Grid>

                                        <Grid
                                            gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}
                                        >
                                            <Box></Box>
                                            <Checkbox
                                                onChange={({ detail }) =>
                                                    setResendOldParameters(detail.checked)
                                                }
                                                checked={resendOldParameters}
                                            >
                                                <SpaceBetween direction="vertical">
                                                    <Box>resend old parameters</Box>
                                                    <span className="last_updated">file_id and triggered_by will be sent by default</span>
                                                </SpaceBetween>
                                            </Checkbox>
                                        </Grid>


                                        <Grid
                                            gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}
                                        >
                                            <Box variant="h4">Parameters</Box>
                                            <RippleMultiInputKeyValue field={"parameters"} getValues={getValue} updateValue={updateValue} reload={reloadParameters} resetReload={resetReload}
                                            ></RippleMultiInputKeyValue>
                                        </Grid>
                                    </SpaceBetween> : <></>
                                }
                                {
                                    approvalOnResults ?
                                        <SpaceBetween direction="vertical" size="xxxs">
                                            <Box variant="h2">Approver(s)</Box>
                                            <SpaceBetween direction="horizontal" size="m">
                                                <Checkbox
                                                    onChange={({ detail }) =>
                                                        setIsDynamicApproversAllowed(detail.checked)
                                                    }
                                                    checked={isDynamicApproversAllowed}
                                                >
                                                    Dynamic approvers
                                                </Checkbox>
                                                <Popover
                                                    dismissButton={false}
                                                    position="top"
                                                    size="small"
                                                    triggerType="custom"
                                                    content={<Box> {DYNAMIC_APPROVERS_INFO} </Box>}
                                                >
                                                    <Button variant="inline-link">info</Button>  </Popover>
                                            </SpaceBetween>
                                            <CustomMultiHybridInputAndSelect field={RippleKeys.APPROVERS}
                                                inputKey={RippleKeys.APPROVER_KEYS.alias} selectKey={RippleKeys.APPROVER_KEYS.type} selectHint="Choose type"
                                                placeholder="alias" getValues={getValue} postProcess={postProcessTeamEmails} validator={approversValidation} mandatoryFieldListener={mandatoryFieldListener}
                                                updateValue={updateValue} getOptions={getSelectFieldValues} info=' ' errorMessage='type and alias input are mandatory' duplicatesNotAllowed={true}
                                                needIndex={true} indexKey={RippleKeys.APPROVER_KEYS.column_index} indexPlaceHolder="Order of approval" defIndex={0}
                                                loginOptions={suggestedLogins} getLoginOptions={getSuggestedLoginsCaller} aliasesLoading={aliasesLoading} />
                                        </SpaceBetween> : ''
                                }
                            </ColumnLayout>
                        </Box>

                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="inline-link" onClick={markDelete} disabled={markedToDelete}>
                                    Remove
                                </Button>
                                <Button variant="inline-link" onClick={unMarkDelete} disabled={!markedToDelete}>
                                    Cancel
                                </Button>
                            </SpaceBetween>
                        </Box>
                    </SpaceBetween> : <Box>
                        <Checkbox
                            disabled={true}
                            checked={props.rippleConfiguration[RippleKeys.approval_required]}
                        >
                            Approval on Results
                        </Checkbox>
                        <ColumnLayout columns={props.rippleConfiguration[RippleKeys.approval_required] ? 2 : 1} borders="vertical">
                            {
                                nextSteps ? <SpaceBetween direction="vertical" size="xxs">
                                    <Box variant="h2">Next steps</Box>
                                    <Grid
                                        gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}
                                    >
                                        <Box variant="h4">Task</Box>
                                        <Box >{props.rippleConfiguration[RippleKeys.task]}</Box>
                                    </Grid>

                                    <Grid
                                        gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}
                                    >
                                        <Box></Box>
                                        <Checkbox
                                            checked={props.rippleConfiguration[RippleKeys.resend_old_parameters]}
                                            disabled={true}
                                        >
                                            <SpaceBetween direction="vertical">
                                                <Box>resend old parameters</Box>
                                                <span className="last_updated">file_id and triggered_by will be sent by default</span>
                                            </SpaceBetween>
                                        </Checkbox>
                                    </Grid>

                                    <Grid
                                        gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}
                                    >
                                        <Box variant="h4">Parameters</Box>
                                        <Table
                                            columnDefinitions={[
                                                {
                                                    id: "field_type",
                                                    header: "Type",
                                                    cell: item => item[RippleKeys.PARAMETER_KEYS.field_type] || "-",
                                                    sortingField: "alt"
                                                },
                                                {
                                                    id: "label",
                                                    header: "Parameter",
                                                    cell: item => item[RippleKeys.PARAMETER_KEYS.label] || "-",
                                                    isRowHeader: true
                                                },
                                                {
                                                    id: "field_values",
                                                    header: "Values",
                                                    cell: item => {
                                                        return item[RippleKeys.PARAMETER_KEYS.field_values]?.join() || item[RippleKeys.PARAMETER_KEYS.field_values]
                                                    },
                                                    isRowHeader: true
                                                },
                                            ]}
                                            items={props.rippleConfiguration[RippleKeys.parameters]?.sort((a, b) => {
                                                if (a.label < b.label) {
                                                    return -1;
                                                }
                                                if (a.label > b.label) {
                                                    return 1;
                                                }
                                                return 0;
                                            })}
                                            loadingText="Loading parameters"
                                            sortingDisabled
                                            empty={
                                                <Box
                                                    margin={{ vertical: "xs" }}
                                                    textAlign="center"
                                                    color="inherit"
                                                >
                                                    <SpaceBetween size="m">
                                                        <b>No parameters</b>
                                                    </SpaceBetween>
                                                </Box>
                                            }
                                            variant='embedded'
                                        />
                                    </Grid>
                                </SpaceBetween> : <></>
                            }
                            {JSON.parse(props.rippleConfiguration[RippleKeys.approval_required]) ?
                                <SpaceBetween direction="vertical" size="m">
                                    <SpaceBetween direction="horizontal" size="m">
                                        <Checkbox
                                            disabled={true}
                                            checked={props.rippleConfiguration[RippleKeys.is_dynamic_approvers_allowed]}
                                        >
                                            Dynamic approvers
                                        </Checkbox>
                                        <Popover
                                            dismissButton={false}
                                            position="top"
                                            size="small"
                                            triggerType="custom"
                                            content={<Box> {DYNAMIC_APPROVERS_INFO} </Box>}
                                        >
                                            <Button variant="inline-link">info</Button>  </Popover>
                                    </SpaceBetween>
                                    <Table
                                        columnDefinitions={[
                                            {
                                                id: "variable",
                                                header: "Type",
                                                cell: item => (item[RippleKeys.APPROVER_KEYS.type] == RIPPLE_APPROVER_TYPES.APPROVER ? 'USER' : 'LDAP') || "-",
                                                isRowHeader: true
                                            },
                                            {
                                                id: "alt",
                                                header: "Alias",
                                                cell: item => item[RippleKeys.APPROVER_KEYS.alias] || "-",
                                                sortingField: "alt"
                                            }
                                        ]}
                                        items={props.rippleConfiguration[RippleKeys.approvers] || []}
                                        loadingText="Loading approver details"
                                        sortingDisabled
                                        empty={
                                            <Box
                                                margin={{ vertical: "xs" }}
                                                textAlign="center"
                                                color="inherit"
                                            >
                                                <SpaceBetween size="m">
                                                    <b>No approvers yet</b>
                                                </SpaceBetween>
                                            </Box>
                                        }
                                        variant='embedded'
                                    />
                                </SpaceBetween>
                                : ''}
                        </ColumnLayout>

                    </Box>
            }



        </SpaceBetween>
    )
}

export default RippleComponent;